// extracted by mini-css-extract-plugin
export default {"container":"Stepper_container__LrP2J","wrapper":"Stepper_wrapper__NYF-h","logo":"Stepper_logo__WAyCg","body":"Stepper_body__UE+zH"};